<template>
  <div id="section6">
    <div class="p5sFondo">
      <div class="p18s6imgfondo">
        <div
          v-responsive.lg.xl
          class="p5Video"
        >
          <video
            autoplay
            controls
            loop
            muted
            preload
            style="width: 100%"
          >
            <source
              :src="p18s6Video"
              type="video/mp4"
            >
          </video>
        </div>   
        <div
          v-responsive.md.sm.xs
          class="p18Img"
        />   
        <b-container fluid>
          <b-container>
            <b-row align-v="center">
              <b-col
                cols="12"
                class="text-center"
              >
                <h2>
                  <div>{{ $t("p18s6title1") }}</div>
                  <div>{{ $t("p18s6title2") }}</div>                  
                </h2>
                <a
                  class="btn buttonWhite-outline"
                  @click="$bvModal.show('pcontact')"
                >
                  <strong>{{ $t("p18s6button2") }}</strong>
                </a>
                <div class="buttonfix2">
                  <strong>{{ $t("p18s6button1") }}</strong>                  
                </div>
              </b-col>
            </b-row>
            <br>
            <br>
          </b-container>
        </b-container>
      </div>      
    </div>
  </div>
</template>

<i18n>
{
  "en":{
    "p18s6title1": "Simplify student access to all internship offers",
    "p18s6title2":  "in companies of reputation and career opportunities",
    "p18s6button1": "Become a partner university",
    "p18s6button2": "Contact us"
  },
  "es":{
    "p18s6title1": "Simplifica el acceso de los estudiantes a todas las ofertas",
    "p18s6title2":  "de prácticas en empresas de prestigio y trayectoria",
    "p18s6button1": "CONVIÉRTETE EN UNIVERSIDAD PARTNER",
    "p18s6button2": "CONTÁCTANOS"
  }
}
</i18n>

<script>
export default {
    data() {
        return {
            p18s6url: "https://jobs.aicad.es",
            p18s6Video: "https://google-my-business.aicad.es/images/video/genesis_480.mp4"

        }
    }
};
</script>

<style lang="scss">
.p18s6imgfondo{
  h2 {
    color: whitesmoke;
    border-radius: 1em;
    padding: 1em;
  };
  p {
    color: whitesmoke;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 1em;
    padding: 1em;
  };
}

.p18Img {
	top: 0;
	bottom: 0;
	position: absolute;
  background-image: linear-gradient(rgba(0, 0, 0, 0.3),rgba(0, 0, 0, 0.3),rgba(0, 0, 0, 0.3),rgba(80,177,177,0.3),rgba(80,177,177,1)),
    url("~@/assets/new_imgs/portada-ofertas-trabajo-aicad.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-position: center center;
  width: 100%;
}


</style>
